import * as React from 'react';
import cx from 'clsx';

import { getRemainingTimeMessage } from './utils';

import { JackpotState, JackpotBoxScale, JackpotStaticTexts } from '../../types';

import styles from './JackpotCountdown.module.scss';

interface JackpotCountdownPropsInterface {
  jackpotScale: JackpotBoxScale;
  jackpotState: JackpotState;
  releaseTime?: string;
  releaseMessage?: string;
  timeStaticTexts: JackpotStaticTexts['time'];
}

const JackpotCountdown: React.FC<JackpotCountdownPropsInterface> = ({
  jackpotScale,
  jackpotState,
  releaseTime,
  releaseMessage,
  timeStaticTexts,
}) => {
  const [highlightedMessage, setHighlightedMessage] = React.useState<string>(
    ''
  );

  React.useEffect(() => {
    let countdownInterval = 0;
    const getHighlightedMessage = (): string => {
      const highlightedMessage =
        jackpotState === 'active' &&
        getRemainingTimeMessage(releaseTime, releaseMessage, timeStaticTexts);
      return highlightedMessage || '';
    };

    const startCountdownInterval = () => {
      if (countdownInterval) {
        // Countdown Interval already active
        if (jackpotState !== 'active') {
          clearInterval(countdownInterval);
          countdownInterval = 0;
          setHighlightedMessage('');
        }
        return;
      }

      if (jackpotState !== 'active') {
        // No need to start an interval if the jackpot status is not active
        return;
      }
      countdownInterval = window.setInterval(() => {
        setHighlightedMessage(getHighlightedMessage());
      }, 1000);
    };

    startCountdownInterval();
    setHighlightedMessage(getHighlightedMessage());

    return () => {
      clearInterval(countdownInterval);
    };
  }, [jackpotState, releaseMessage, releaseTime, timeStaticTexts]);

  const className = cx(
    styles.container,
    jackpotScale === 'tiny' && styles.tiny
  );

  return highlightedMessage ? (
    <div className={className} data-testid="jackpot-bottom">
      {highlightedMessage}
    </div>
  ) : (
    <div
      className={cx(className, styles.dummy)}
      data-testid="jackpot-bottom-dummy"
    >
      -
    </div>
  );
};

export default JackpotCountdown;
